import { api } from "./api";
import { notifyError } from "./error";
import * as UserActions from "./user";

export const getRegistrations = (event_id) =>
    api.get(`events/${event_id}/athletes/registrations`);

export const getMemberships = (series_id) =>
    api.get(`seasons/${series_id}/memberships/current_user_memberships`);

export const createMemberships = (series_id, values) =>
    dispatch =>
        api.post(`seasons/${series_id}/memberships`, values)
            .then(() => {
                dispatch(UserActions.getCurrentUser());
            }, notifyError(dispatch));
